export const reportsIt: Record<string, string> = {
  'reports.title': 'Report',
  'reports.subtitle': 'Business intelligence e analisi',
  'reports.overview': 'Panoramica',
  'reports.revenue': 'Ricavi',
  'reports.cashflow': 'Flusso di cassa',
  'reports.operational': 'Operativo',
  'reports.this_month': 'Questo mese',
  'reports.last_month': 'Mese scorso',
  'reports.last_3_months': 'Ultimi 3 mesi',
  'reports.ytd': 'Da inizio anno',
  'reports.revenue_label': 'Ricavi',
  'reports.growth': 'Crescita',
  'reports.orders_created': 'Ordini creati',
  'reports.outstanding': 'In sospeso',
  'reports.overdue_invoices': 'Fatture scadute',
  'reports.revenue_trend': 'Andamento ricavi',
  'reports.by_payment_method': 'Per metodo di pagamento',
  'reports.upcoming_deliveries': 'Consegne in arrivo (14 giorni)',
  'reports.overdue_invoices_table': 'Fatture scadute',
  'reports.revenue_period': 'Ricavi (Periodo)',
  'reports.revenue_ytd': 'Ricavi YTD',
  'reports.avg_per_order': 'Media per ordine',
  'reports.paying_customers': 'Clienti paganti',
  'reports.revenue_breakdown': 'Dettaglio ricavi',
  'reports.by_month': 'Per mese',
  'reports.by_brand': 'Per marca',
  'reports.by_category': 'Per categoria',
  'reports.by_payment': 'Per pagamento',
  'reports.collected_this_month': 'Incassato questo mese',
  'reports.collected_last_month': 'Incassato mese scorso',
  'reports.outstanding_total': 'Totale in sospeso',
  'reports.overdue_total': 'Totale scaduto',
  'reports.avg_days_to_pay': 'Giorni medi al pagamento',
  'reports.invoice_aging': 'Anzianità fatture',
  'reports.payment_timeline': 'Timeline pagamenti',
  'reports.order_pipeline': 'Pipeline ordini',
  'reports.delivery_forecast': 'Previsione consegne (Previsto)',
  'reports.tailoring_insight': 'Insight sartoria',
  'reports.avg_tailoring_cost': 'Costo medio sartoria',
  'reports.cost_pct_of_order': 'Costo % dell\'ordine',
  'reports.orders_above_threshold': 'Ordini sopra soglia',
  'reports.total_orders': 'Ordini totali',
  'reports.order': 'Ordine',
  'reports.customer': 'Cliente',
  'reports.date': 'Data',
  'reports.unpaid': 'Non pagato',
  'reports.invoice': 'Fattura',
  'reports.days': 'Giorni',
  'reports.due': 'Dovuto',
  'reports.paid': 'Pagato',
  'reports.name': 'Nome',
  'reports.pct_total': '% Totale',
  'reports.units': 'Unità',
  'reports.avg_value': 'Valore medio',
  'reports.bucket': 'Fascia',
  'reports.count': 'Conteggio',
  'reports.amount': 'Importo',
  'reports.monthly': 'Mensile',
  'reports.weekly': 'Settimanale',
  'reports.this_week': 'Questa settimana',
  'reports.last_week': 'Settimana scorsa',
  'reports.no_data_title': 'Nessun dato ancora',
  'reports.no_data_subtitle': 'Ordini e pagamenti appariranno qui una volta registrati.',
  'reports.error_title': 'Si è verificato un errore nel caricamento.',
  'reports.retry': 'Riprova',
  'reports.view_all': 'Vedi tutti',
  'reports.export_csv': 'Esporta CSV',
  'reports.export_pdf': 'Esporta PDF',
  'reports.coming_soon': 'In arrivo',
  'reports.sort_asc': 'Ordine crescente',
  'reports.sort_desc': 'Ordine decrescente',
  'reports.all_deliveries': 'Tutte le consegne in arrivo',
  'reports.all_overdue': 'Tutte le fatture scadute',
  'reports.back_to_overview': 'Torna alla panoramica',
  'reports.download': 'Scarica',
  'reports.exported': 'Esportato con successo',
  'reports.compare_previous': 'Confronta con periodo precedente',
  'reports.vs_previous': 'vs periodo precedente',
  'reports.revenue_recognition_note': 'I ricavi sono riconosciuti al ricevimento del pagamento (solo pagamenti riusciti).',
  'reports.projected': 'Previsto',
  'reports.not_recognized': 'Non ancora riconosciuto',
  'reports.cash_received_this_month': 'Incasso ricevuto (Questo mese)',
  'reports.cash_received_last_month': 'Incasso ricevuto (Mese scorso)',
  'reports.outstanding_tooltip': 'Saldo totale non pagato su tutti gli ordini, non filtrato per il periodo selezionato',
  'reports.custom_range': 'Intervallo personalizzato',
  'reports.custom_range_hint': 'Disponibile con dati reali',
  'reports.insufficient_history': 'Dati storici insufficienti per il confronto',
  'reports.daily': 'Giornaliero',
  'reports.custom_range_start': 'Data inizio',
  'reports.custom_range_end': 'Data fine',
  'reports.custom_range_apply': 'Applica',
  'reports.customers': 'Clienti',
  'reports.new_customers': 'Nuovi clienti',
  'reports.repeat_customers': 'Clienti abituali',
  'reports.avg_revenue_per_customer': 'Ricavo medio / Cliente',
  'reports.top_customers': 'Top clienti per ricavo',
  'reports.last_order': 'Ultimo ordine',
  'reports.orders_count': 'Ordini',
  'reports.next_14_days': '14 giorni',
  'reports.next_1_month': '1 mese',
  'reports.next_3_months': '3 mesi',
  'reports.upcoming_deliveries_title': 'Consegne in arrivo',
  'reports.revenue_ytd_tooltip': 'Ricavi totali dal 1 Gen {year} ad oggi',
  'reports.orders_column': 'Ordini',
  'reports.items_sold': 'Articoli venduti',
  'reports.paying_customers_tooltip': 'Clienti unici con almeno un pagamento riuscito nel periodo selezionato',
  'reports.forecast': 'Previsioni',
  'reports.scheduled_revenue': 'Ricavi programmati',
  'reports.historical_baseline': 'Baseline storico',
  'reports.predicted_total': 'Totale previsto',
  'reports.coverage_pct': 'Copertura %',
  'reports.scheduled': 'Programmato',
  'reports.historical': 'Storico',
  'reports.forecast_subtitle': 'Basato sulle scadenze delle richieste di pagamento e sui ricavi dello stesso periodo dell\'anno scorso',
  'reports.scheduled_tooltip': 'Richieste di pagamento non pagate con scadenza in questo periodo',
  'reports.historical_tooltip': 'Pagamenti effettivi ricevuti negli stessi mesi un anno fa',
  'reports.at_risk_orders': 'Ordini a rischio',
  'reports.no_at_risk': 'Tutti gli ordini in regola — nessun problema rilevato',
  'reports.tailoring_queue': 'Coda sartoria',
  'reports.pending_tasks': 'In attesa',
  'reports.in_progress_tasks': 'In corso',
  'reports.overdue_tasks': 'In ritardo',
  'reports.avg_days_in_status': 'Giorni medi',
  'reports.delivery_readiness': 'Prontezza consegne per mese',
  'reports.ready': 'Pronti',
  'reports.still_in_progress': 'ancora in corso',
  'reports.status': 'Stato',
  'reports.demo_banner_title': 'Dati demo',
  'reports.demo_banner_description': 'Stai visualizzando dati di esempio a scopo dimostrativo. Questi non sono i dati reali della tua attività.',
};
